import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { canUseDOM, getUserPremiumStatus, getWavetrakIdentity } from '@surfline/web-common';
import { NotFound, FiveHundred } from '@surfline/quiver-react';
import { getStatusCode } from '../../selectors/status';

class KBYGPageContainer extends Component {
  componentDidMount() {
    const identity = getWavetrakIdentity();
    if (canUseDOM && window.analytics && window.analytics.user) {
      if (identity?.type === 'logged_in') {
        window.analytics.identify(identity.userId, { sourceOrigin: 'KBYG' });
      }
    }
  }

  getClassName = () => {
    const { isPremium } = this.props;

    return classNames({
      'sl-kbyg-page-container': true,
      'sl-kbyg-page-container--is-premium': isPremium,
    });
  };

  pageContent = () => {
    const { status, children } = this.props;
    if (status === 404) {
      return <NotFound />;
    }
    if (status === 500) {
      return <FiveHundred />;
    }
    return children;
  };

  render() {
    return (
      <>
        <div className={this.getClassName()}>{this.pageContent()}</div>
        <div id="modal-root" />
      </>
    );
  }
}

KBYGPageContainer.propTypes = {
  children: PropTypes.node,
  status: PropTypes.number.isRequired,
  isPremium: PropTypes.bool.isRequired,
};

KBYGPageContainer.defaultProps = {
  children: null,
};

export default connect((state) => ({
  status: getStatusCode(state),
  isPremium: getUserPremiumStatus(state),
}))(KBYGPageContainer);
